import React, { useEffect, useState } from 'react';
import * as uuid from 'uuid';
import { RgbaColor } from '@uiw/color-convert';
import { RgbwChannelSettings } from '../../../../../../../modules/action-create/channel-settings/rgbw';
import { RGBWStateTask } from '../../../../../../../types/actions';
import { rgbaToRgbString } from '../../../../../../../utils/helpers';
import { useLavvaCreateActionContext } from '../../../context';
import { useTaskEdit } from '../../../hooks/use-task-edit';
import { DeviceTaskParams, SceneTaskType, Task } from '../../../types';

export const RGBWSettings: React.FC = () => {
  const { channels, taskVariant } = useLavvaCreateActionContext();
  const { task, finalizeDeviceTaskSubmit } = useTaskEdit();
  const [rgbValue, setRgbValue] = useState<string>('');

  useEffect(() => {
    const R = 49;
    const G = 255;
    const B = 67;
    setRgbValue(`${R.toString()},${G.toString()},${B.toString()}`);
  }, []);

  useEffect(() => {
    if (task) {
      const params = (task.taskParams as DeviceTaskParams).state as RGBWStateTask;
      setRgbValue(`${params.R.toString()},${params.G.toString()},${params.B.toString()}`);
    }
  }, [task]);

  const handleColorPicked = (rgba: RgbaColor) => {
    const rgb = rgbaToRgbString(rgba);
    setRgbValue(rgb);
  };

  const handleSubmit = () => {
    for (let i = 0; i < channels.length; i++) {
      const values = rgbValue.split(',');
      const R = parseInt(values[0]);
      const G = parseInt(values[1]);
      const B = parseInt(values[2]);

      const task: Task = {
        id: uuid.v4(),
        taskType: SceneTaskType.ChannelState,
        taskParams: {
          state: {
            R,
            G,
            B,
          } as RGBWStateTask,
          channel: channels[i],
          variant: taskVariant,
        } as DeviceTaskParams,
      };

      finalizeDeviceTaskSubmit(task, i === channels.length - 1);
    }
  };

  return <RgbwChannelSettings rgbValue={rgbValue} handleColorPicked={handleColorPicked} handleSubmit={handleSubmit} />;
};
